<template>
  <app-layout>
    <template #header>
      <div class="flex justify-between">
        <Breadcrumb :items="[
      {
          label : 'Home',
          link : '/',
      },
      {
          label : 'Entrevistas',
          link :  route('entrevista.index'),
      }
      ]"></Breadcrumb>
        <div>
          <inertia-link :href="route('entrevista.create')">Novo</inertia-link>
        </div>
      </div>

    </template>
    <div>
      <div class="max-w-7xl mx-auto py-6 sm:px-4 relative">
        <div class="absolute right-3 top-2  flex flex-row space-x-3">
          <div class="w-6">
           <a
              target="_blank"
              :href="link_export"
            >
              <ExcelIcon></ExcelIcon>
            </a>

          </div>
          <SearchButton
            :campos="campos"
            :filter-initial="initialFilters"
            @apply="aplicarFiltro"
          ></SearchButton>
        </div>
        <div class="grid grid-cols-1 mt-4 space-y-6">
          <div>
            <status-cards
              :states="states"
              @apply="aplicarFiltroState"
            ></status-cards>
          </div>
          <div>
            <div class="flex flex-col space-y-4">
              <ListItem
                v-for="item in entrevistas.data"
                :key="item.id"
                :entrevista="item"
              ></ListItem>
            </div>
          </div>
          <div class="flex justify-center">
            <el-pagination
              :pager-count="5"
              background
              layout="prev, pager, next"
              :total="entrevistas.total"
              :page-size="entrevistas.per_page"
              :current-page="entrevistas.current_page"
              @current-change="changePage"
              :hide-on-single-page="true"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/AppLayout';
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label';
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';
import SearchButton from '@/Components/SearchButton';
import StatusCards from './StatusCards';
import ListItem from './ListItem';
import ExcelIcon from '@/Components/Icons/Excel';
import Breadcrumb from '@/Components/Breadcrumb';

export default {
  name: 'EntrevistaIndex',
  components: {
    AppLayout,
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
    ButtonPrimary,
    ButtonSecondary,
    StatusCards,
    SearchButton,
    ListItem,
    ExcelIcon,
    Breadcrumb,
  },
  props: ['states', 'entrevistas', 'initialFilters' , 'link_export'],
  data() {
    const campos = {
      nome: {
        label: 'Nome',
        field: 'nome',
        type: 'input',
        config: {

        }
      },
      cpf: {
        label: 'Cpf',
        field: 'cpf',
        type: 'input',
        config: {
        }
      },
      id: {
        label: 'Entrevista ID',
        field: 'id',
        type: 'number',
        config: {
        }
      },
      funcao_id: {
        label: 'Função',
        field: 'funcao_id',
        type: 'select',
        config: {
          placeholder: 'Função',
          primarykey: 'id',
          label: 'nome',
          urlSearch: '/api/select/funcao',
          objectReturn: true
        }
      },
      centro_custo_id: {
        label: 'Centro Custo',
        field: 'centro_custo_id',
        type: 'select',
        config: {
          placeholder: 'Centro Custo',
          primarykey: 'id',
          label: 'nome',
          urlSearch: '/api/select/centro-custo',
          objectReturn: true
        }
      },
      user_id: {
        label: 'Solicitante',
        field: 'user_id',
        type: 'select',
        config: {
          placeholder: 'Solicitante',
          primarykey: 'id',
          label: 'name',
          urlSearch: '/api/select/user',
          objectReturn: true
        }
      },
      state: {
        label: 'Status',
        field: 'state',
        type: 'select',
        config: {
          placeholder: 'Status',
          primarykey: 'id',
          label: 'nome',
          items: [
            ...Object.values(this.states)
          ]
        }
      },
      created_at: {
        label: 'Incluído',
        field: 'created_at',
        type: 'daterange',
        config: {
          placeholder: 'Incluído',
          valueFormat: 'yyyy-MM-dd'
        }
      },
    };
    return {
      isLoading: false,
      currentPage: 1,
      page: 1,
      totalRegistros: 0,

      campos
    }
  },
  methods: {
    aplicarFiltroState(stateId) {
      const state = this.states[stateId]
      this.aplicarFiltro([{
        field: 'state',
        label: `Status igual ${state.nome}`,
        operator: "equal",
        value: state.id
      }]);
    },
    aplicarFiltro(filters) {
      this.$inertia.get(
        this.route('entrevista.index', {
          filters: filters,
          'page': this.page
        })
        , {}, { replace: true });
    },
    changePage(event) {
      this.isLoading = true;
      this.$inertia.get(
        this.route('entrevista.index', {
          filters: this.initialFilters,
          'page': event
        })
        , {}, { replace: true });
    }
  }
}
</script>

<style>
</style>
